define('configuration/navigation.configuration',['require','exports','module','underscore','fukit/fukit','navigation'],function(require, exports, module) {
  //prettier-ignore
  var _               = require('underscore'),
      FuKit           = require('fukit/fukit'),
      localNavigation = require('navigation');

  var LocalNavigationConfiguration = _.extend({}, FuKit.NavigationConfiguration, {
    options: {
      navigation: localNavigation,
    },
  });

  module.exports = LocalNavigationConfiguration;
});

